module.exports = __webpack_public_path__ + "static/media/list-filled.2d34a67f.svg";